import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('user.shared-accounts.access-requests.create', {
        url: '/create',
        views: {
            '@user.shared-accounts': 'createAccessRequest',
        },
        resolve: {companies},
    })
}

/** @ngInject */
function companies(AccessRequestsService){
    return AccessRequestsService.getCompanies();
}


// WEBPACK FOOTER //
// ./src/portal/states/user/access-requests/create/create-access-request.state.js